import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import TestPage from './pages/TestPage';
import ResultsPage from './pages/ResultsPage';
import AdminDashboard from './pages/AdminDashboard';
import AdminLogin from './pages/AdminLogin';
import AdminLayout from './components/Layout/AdminLayout';
import CandidateManagement from './pages/CandidateManagement';
import BulkInvite from './pages/BulkInvite';
import AssessmentManagement from './pages/AssessmentManagement';
import PhoneVerification from './components/PhoneVerification';
import CandidateReport from './pages/CandidateReport';
import TestReport from './pages/TestReport';
import { LanguageProvider } from './contexts/LanguageContext';

// Protected route wrapper with better checking
const ProtectedRoute = ({ children }) => {
    const token = localStorage.getItem('adminToken');
    const user = localStorage.getItem('adminUser');

    console.log('ProtectedRoute - Token:', !!token, 'User:', !!user);

    if (!token || !user) {
        console.log('Not authenticated, redirecting to login');
        return <Navigate to="/admin/login" replace />;
    }

    return children;
};

function App() {
    console.log('App rendering');

    return (
        <LanguageProvider>
            <Router>
                <Routes>
                    {/* Candidate Routes */}
                    <Route path="/test/:accessToken" element={<TestPage />} />
                    <Route path="/results/:accessToken" element={<ResultsPage />} />
                    <Route path="/ethicroute/:phoneToken" element={<PhoneVerification />} />
                    <Route path="/admin/login" element={<AdminLogin />} />
                    <Route path="/admin/test-report/:accessToken" element={<TestReport />} />
                    <Route path="/admin/candidates/:candidateId/report" element={<CandidateReport />} />
                    <Route path="/admin" element={
                        <ProtectedRoute>
                            <AdminLayout />
                        </ProtectedRoute>
                    }>
                        <Route index element={<AdminDashboard />} />
                        <Route path="assessments" element={<AssessmentManagement />} />
                        <Route path="candidates" element={<CandidateManagement />} />
                        <Route path="invite" element={<BulkInvite />} />
                        <Route path="analytics" element={<AdminDashboard />} />
                        <Route path="settings" element={<div>Settings Page</div>} />
                    </Route>

                    {/* SSO Callback Routes */}
                    <Route path="/auth/sso/success" element={
                        (() => {
                            const params = new URLSearchParams(window.location.search);
                            const token = params.get('token');
                            if (token) {
                                localStorage.setItem('adminToken', token);
                                window.location.href = '/admin';
                            }
                            return null;
                        })()
                    } />
                    <Route path="/auth/sso/error" element={
                        <div className="min-h-screen flex items-center justify-center">
                            <div className="text-center">
                                <h1 className="text-2xl font-bold text-red-600 mb-4">Authentication Error</h1>
                                <p className="text-gray-600">Please contact your administrator.</p>
                                <button
                                    onClick={() => window.location.href = '/admin/login'}
                                    className="mt-4 px-4 py-2 bg-[#0a4a6a] text-white rounded"
                                >
                                    Back to Login
                                </button>
                            </div>
                        </div>
                    } />

                    {/* Home - Redirect to admin or show landing */}
                    <Route path="/" element={
                        <div className="min-h-screen flex items-center justify-center bg-gray-100">
                            <div className="bg-white p-8 rounded-lg shadow-lg text-center max-w-md">
                                <h1 className="text-2xl font-bold text-indigo-600 mb-4">Psychometric Assessment</h1>
                                <p className="text-gray-600 mb-6">
                                    Please use the link provided by your administrator to access your assessment.
                                </p>
                                <hr className="my-4" />
                                <a href="/admin/login" className="text-indigo-600 hover:text-indigo-800">
                                    Admin Login →
                                </a>
                                <p className="text-sm text-gray-400 mt-4">
                                    © {new Date().getFullYear()} PsychCatalyst. All rights reserved.
                                </p>
                            </div>
                        </div>
                    } />

                    {/* 404 */}
                    <Route path="*" element={
                        <div className="min-h-screen flex items-center justify-center">
                            <div className="text-center">
                                <h1 className="text-4xl font-bold text-gray-800 mb-4">404</h1>
                                <p className="text-gray-600">Page not found</p>
                                <a href="/" className="mt-4 inline-block text-indigo-600">Go Home</a>
                            </div>
                        </div>
                    } />
                </Routes>
            </Router>
        </LanguageProvider>
    );
}

export default App;